export class FlowService {

    /* @ngInject */
    constructor(egUrlService, flowStateService, $log, $http, $q, $state) {
        this.egUrlService = egUrlService;
        this.flowStateService = flowStateService;
        this.$log = $log;
        this.$http = $http;
        this.$q = $q;
        this.$state = $state;
    }

    initFlow(requestingWorkerName, destinationResource, nspIdCardRequired, securityContext, installationUserId) {
        let url = this.egUrlService.url(
            '/authentication/flow' +
            '?workerName={{workerName}}' +
            '&installationUserId={{installationUserId}}' +
            '&destinationResource={{destinationResource}}' +
            '&nspIdCardRequired={{nspIdCardRequired}}' +
            '&securityContext={{securityContext}}',
            {
                workerName: requestingWorkerName ? requestingWorkerName : "",
                installationUserId: installationUserId ? installationUserId : "",
                destinationResource: destinationResource ? destinationResource : "",
                nspIdCardRequired: nspIdCardRequired ? nspIdCardRequired : "false",
                securityContext: securityContext ? securityContext : ""
            }
        );

        this.flowStateService.setInstallationUserId(installationUserId);

        this.$http.get(url)
            .then(() => this.nextFlow())
            .catch(response => this.requestError(response));
    }

    nextFlow() {
        let url = this.egUrlService.url('/authentication/flow/next');
        this.$http.post(url, this.flowStateService.getFlowState())
            .then(response => this.requestSuccess(response))
            .catch(response => this.requestError(response));
    }

    requestSuccess(response) {
        this.$log.log('Response from FlowWebService: ', response.data);
        this.flowStateService.update(response.data);

        switch (response.data.flowState) {
            case 'CHOOSE_AUTHENTICATION_MECHANISM':
                this.$state.go('chooseMechanism');
                break;
            case 'ACTIVATE_ACCOUNT':
                this.$state.go('activate.help', {
                    state: 'ACTIVATE'
                });
                break;
            case 'TWO_FACTOR_VERIFICATION':
                this.$state.go('verifycode', {
                    type: 'VERIFY_DEVICETOKEN'
                });
                break;
            case 'UNAPPROVED_DEVICE_TOKEN':
                this.$state.go('deviceTokenInfo');
                break;
            case 'CHOOSE_INSTALLATION':
                this.$state.go('installationlist');
                break;
            case 'NO_INSTALLATION_USER_ACCOUNT':
                this.$state.go('login.account', {authenticationRequired: true});
                break;
            case 'PROVIDE_REASON':
                this.$state.go('loginReason');
                break;
            case 'REDIRECT_TO_DESTINATION':
                this.$state.go('redirectToDestination');
                break;
        }
    }

    requestError(response) {
        this.$log.error('There was an error requesting the session status: ' + response.data);
        return this.$q.reject(response.statusText);
    }
}
